import { useLanguage } from "@/context/LanguageContext";
import { useGlobalContext } from "@/hooks/useGlobalContext";
import { limitText } from "@/utils";
import React, { Fragment, useState } from "react";
import ProgressiveImage from "../ui/ProgressiveImage";
import VideoModal from "../ui/VideoModal";
import { Post } from "@/constants/types";
import Link from "next/link";

const AboutSection = ({ isHome = true }: { isHome?: boolean }) => {
  const { t } = useLanguage();
  const { settings, videos } = useGlobalContext();
  const [selectedVideo, setSelectedVideo] = useState<Post | any | null>(null);
  const handleOpenVideo = () => {
    setSelectedVideo(videos ? (videos[0] as Post) : undefined);
    document.body.style.overflow = "hidden"; // Empêche le défilement du corps
  };

  const handleCloseVideo = () => {
    setSelectedVideo(null);
    document.body.style.overflow = "auto"; // Empêche le défilement du corps
  };
  return (
    <div className="tp-about__area tp-about__space">
      <div className="container">
        <div className="row align-items-xl-start align-items-center">
          <div
            className="col-xl-7 col-lg-7 wow tpfadeLeft"
            data-wow-duration=".9s"
            data-wow-delay=".3s"
          >
            <div className="tp-about__left-side">
              <div className="tp-about__section-title pb-25">
                <span className="tp-section-subtitle">{t("AboutUs")}</span>
                <h4 className="tp-section-title">{t("Welcome")}</h4>
              </div>
              <div className="tp-about__content">
                <div
                  className="tp-about__text"
                  dangerouslySetInnerHTML={{
                    __html: isHome
                      ? limitText(settings?.about, 300)
                      : settings?.about,
                  }}
                ></div>
                {isHome && (
                  <Fragment>
                    <div className="tp-about__wraper pb-40 d-flex justify-content-between">
                      <div className="tp-about__list-item d-flex align-items-start">
                        {/* <div className="tp-about__list-icon">
                          <i className="flaticon-check-mark-black-outline"></i>
                        </div>
                        <div className="tp-about__list-content">
                          <h4 className="tp-about__title-sm">Join Our Team</h4>
                          <p>
                            Charity Navigator's Giving you <br /> support
                            multiple
                          </p>
                        </div> */}
                      </div>
                    </div>

                    <div className="tp-about__bottom d-flex">
                      <div className="tp-about__btn">
                        <Link className="tp-btn" href="/about-us">
                          {t("ReadMore")}
                        </Link>
                      </div>
                    </div>
                  </Fragment>
                )}
              </div>
            </div>
          </div>
          <div
            className="col-xl-5 col-lg-5 wow tpfadeRight"
            data-wow-duration=".9s"
            data-wow-delay=".9s"
          >
            <div className="tp-about__main-thumb text-lg-end text-center p-relative">
              <ProgressiveImage
                className={"img-1"}
                url={settings?.aboutImage}
              />
              {isHome && (
                <div className="tp-about__thumb-sm">
                  <ProgressiveImage url={settings?.missionImage} />
                </div>
              )}
              {videos && videos?.length > 0 && (
                <div className="tp-about__icon d-none d-lg-block">
                  <a role="button" onClick={handleOpenVideo} className="popup-video">
                    <i className="fas fa-play"></i>
                  </a>
                </div>
              )}
            </div>
          </div>
        </div>

        <VideoModal
          isOpen={!!selectedVideo}
          onClose={handleCloseVideo}
          videoId={selectedVideo?.file || ""}
          title={selectedVideo?.title || ""}
        />
      </div>
    </div>
  );
};

export default AboutSection;
